export const CREATE_ARTIST = '[Artist] Create artist';
export const CREATE_ARTIST_SUCCESS = '[Artist] Create artist Success';
export const CREATE_ARTIST_ERROR = '[Artist] Create artist Error';

export const UPDATE_ARTIST = '[Artist] Update artist';
export const UPDATE_ARTIST_SUCCESS = '[Artist] Update artist Success';
export const UPDATE_ARTIST_ERROR = '[Artist] Update artist Error';

export const GET_ARTISTS = '[Artist] Get user artists';
export const GET_ARTISTS_SUCCESS = '[Artist] Get user artists Success';
export const GET_ARTISTS_ERROR = '[Artist] Get user artists Error';

export const DEACTIVATE_ARTIST = '[Artist] Deactivate artist';
export const DEACTIVATE_ARTIST_SUCCESS = '[Artist] Deactivate artist Success';
export const DEACTIVATE_ARTIST_ERROR = '[Artist] Deactivate artist Error';

export const RESTORE_DEACTIVATED_ARTIST = '[Artist] Restore deactivated artist';
export const RESTORE_DEACTIVATED_ARTIST_SUCCESS =
  '[Artist] Restore deactivated artist Success';
export const RESTORE_DEACTIVATED_ARTIST_ERROR =
  '[Artist] Restore deactivated artist Error';

export const GET_ARTIST_TEAM = '[Artist] Get artist team';
export const GET_ARTIST_TEAM_SUCCESS = '[Artist] Get artist team Success';
export const GET_ARTIST_TEAM_ERROR = '[Artist] Get artist team Error';

export const REMOVE_FROM_ARTIST_TEAM = '[Artist] Remove from artist team';
export const REMOVE_FROM_ARTIST_TEAM_SUCCESS =
  '[Artist] Remove from artist team Success';
export const REMOVE_FROM_ARTIST_TEAM_ERROR =
  '[Artist] Remove from artist team Error';

export const SWITCH_TEAM_MEMBER_ROLE = '[Artist] Switch Team Member Role';
export const SWITCH_TEAM_MEMBER_ROLE_SUCCESS =
  '[Artist] Switch Team Member Role Success';
export const SWITCH_TEAM_MEMBER_ROLE_ERROR =
  '[Artist] Switch Team Member Role Error';

export const SEARCH_ARTISTS = '[Artist] Search artists';
export const SEARCH_ARTISTS_SUCCESS = '[Artist] Search artists Success';
export const SEARCH_ARTISTS_ERROR = '[Artist] Search artists Error';
export const SEARCH_ARTISTS_RESET = '[Artist] Search artists Reset';
export const SEARCH_EXTERNAL_ARTISTS_RESET =
  '[Artist] Search External artists Reset';

export const SEARCH_EXTERNAL_ARTISTS = '[Artist] Search external artists';
export const SEARCH_EXTERNAL_ARTISTS_SUCCESS =
  '[Artist] Search external artists Success';
export const SEARCH_EXTERNAL_ARTISTS_ERROR =
  '[Artist] Search external artists Error';

export const SET_ACTIVE_ARTIST = '[Artist] Set active';

export const UPDATE_PAGE_FIELD = '[Artist] Update Profile Page Field';
export const UPDATE_PAGE_SECTION_FIELD =
  '[Artist] Update Profile Section Page Field';

export const REMOVE_PROFILE_IMAGE = '[Artist] Remove Profile Image';
export const REMOVE_PROFILE_IMAGE_SUCCESS =
  '[Artist] Remove Profile Image Success';
export const REMOVE_PROFILE_IMAGE_ERROR = '[Artist] Remove Profile Image Error';

export const GET_ARTIST_PAGE = '[Artist] Get Artist Page';
export const GET_ARTIST_PAGE_SUCCESS = '[Artist] Get Artist Page Success';
export const GET_ARTIST_PAGE_ERROR = '[Artist] Get Artist Page Error';

export const UPDATE_ARTIST_PAGE = '[Artist] Update Artist Page';
export const UPDATE_ARTIST_PAGE_SUCCESS = '[Artist] Update Artist Page Success';
export const UPDATE_ARTIST_PAGE_ERROR = '[Artist] Update Artist Page Error';

export const PUBLISH_ARTIST_PAGE = '[Artist] Publish Artist Page';
export const PUBLISH_ARTIST_PAGE_SUCCESS =
  '[Artist] Publish Artist Page Success';
export const PUBLISH_ARTIST_PAGE_ERROR = '[Artist] Publish Artist Page Error';

export const RESET_ARTIST_STORE = '[Artist] Reset Store';

export const CREATE_ARTIST_INVITE = '[Artist] Create Artist Invite';
export const CREATE_ARTIST_INVITE_SUCCESS =
  '[Artist] Create Artist Invite Success';
export const CREATE_ARTIST_INVITE_ERROR = '[Artist] Create Artist Invite Error';

export const UPDATE_ARTIST_DATA = '[Artist] Update Artist Data';

export const UPDATE_ARTISTS_PLATFORMS = '[Artist] Update Artists Platforms';
export const UPDATE_ARTISTS_PLATFORMS_SUCCESS =
  '[Artist] Update Artists Platforms Success';
export const UPDATE_ARTISTS_PLATFORMS_ERROR =
  '[Artist] Update Artists Platforms Error';

export const GET_ACHIEVEMENTS = '[Artist] Get Achievements';
export const GET_ACHIEVEMENTS_SUCCESS = '[Artist] Get Achievements Success';
export const GET_ACHIEVEMENTS_ERROR = '[Artist] Get Achievements Error';

export const UPDATE_ACHIEVEMENT = '[Artist] Update Achievement';
export const UPDATE_ACHIEVEMENT_SUCCESS = '[Artist] Update Achievement Success';
export const UPDATE_ACHIEVEMENT_ERROR = '[Artist] Update Achievement Error';

export const VALIDATE_EXTERNAL_ARTIST_ID =
  '[Artist] Validate External Artist Id';
export const VALIDATE_EXTERNAL_ARTIST_ID_SUCCESS =
  '[Artist] Validate External Artist Id Success';
export const VALIDATE_EXTERNAL_ARTIST_ID_ERROR =
  '[Artist] Validate External Artist Id Error';
